import { useRef, useEffect } from 'react'

import { createMoEController } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/marginOfError'

// Creates a per-chart MoE controller that survives re-renders (lives outside React state),
// keeps its live config in sync each render, and tears down on unmount.
// The controller is created for every chart but only ACTS where a leaf builder calls
// wireMoEEvents (column/bar/dataLab); pie/scatter/etc. builders never wire it, so it stays idle.
// `props.moeParams` lets a chart customize the engine (getMode / selectNonSig / dimOthers) — dataLab.
export const useMarginOfError = props => {
  const ref = useRef(null)
  if (!ref.current) ref.current = createMoEController(props.moeParams)

  // Handlers read the live config from here, so a confidenceLevel/significanceLevel change
  // does not require rebuilding the event closures — the next redraw re-reads it (S6).
  ref.current.config = {
    confidenceLevel: props.confidenceLevel,
    significanceLevel: props.significanceLevel,
    confidenceLevels: props.confidenceLevels,
    format: props.format,
    qType: props.qType,
    answerType: props.answerType,
    ignorePercents: props.ignorePercents,
    axisType: props.axisType,
    chartMode: props.chartMode,
    viewMode: props.viewMode,
    groupType: props.groupType, // dataLab: drives grouped/interlaced non-sig selection
    percentDecimals: props.percentDecimals ?? props.format?.percentDecimals ?? props.reportPercentDecimals ?? 1
  }

  useEffect(() => () => ref.current?.destroy(), []) // S8: clearTimeout + drop overlay on unmount

  return ref.current
}
